import React, {useState, useEffect } from "react";
import { connect } from "react-redux";
import { ls } from "../../../locale";
import { ListGroup, Button } from "react-bootstrap";

import "./index.scss";
import { commonHelpers, isInAppBrowser, webkitHelper, stringFormatter } from "../../../helpers";
import { bookingActions } from "../../../state/ducks/booking";
import { sessionActions } from "../../../state/ducks/session";
import { wciActions } from "../../../state/ducks/wci";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import StatusBar from "../../../components/StatusBar";
import FlightDetail from "./FlightDetail";
import Backdrop from "../../../components/Backdrop";
import AlertBox from "../../../components/Common/AlertBox";
import { pushWciCompleteEvent } from "../../../helpers/dataLayer";
import { useLocation } from "react-router-dom";

import RatingBar from "../../../components/RatingBar";

const ratingKey = 'Feedback.WCI.Items.Q1'
const feedbackKey = 'Feedback.WCI.Thanks'

function Confirmation({ booking, getBookingWithAllSegments, getBookingSummary, getBoardingPass, getBookingMode, match, feedback }) {
  const location = useLocation();

  const [rated, setRated] = useState(0);
  const [redirectedFrom, setRedirectedFrom] = useState(null);
  const [paymentStatus] = useState(location.state?.payment);

  useEffect(() => {
    getBookingWithAllSegments().then(booking => {
      if (booking && booking.pnr) {
        const bookingMode = getBookingMode();
        pushWciCompleteEvent(booking.pnr, bookingMode?.ref);
      }
    });
    getBookingSummary();
  }, []);

  useEffect(() => {
    setRedirectedFrom(location.state ? location.state.from : null);
  }, []);

  const onBoardingPass = () => {
    // check if webkit is available; if yes, it's in app browser
    if (webkitHelper.sendPrintBoardingPass()) return;

    getBoardingPass().then((response) => {
      commonHelpers.createDownloadTag(response, 'boarding-pass.pdf');
    });
  };

  const sendFeedback = rating => {
    if(!rating) return;

    const data = {
      items: [{
        key: ratingKey,
        rating
      }]
    }

    feedback(data).then(() => {
      //console.log('rated');
      setRated(rating);
    })
  }

  if (!booking) return null;

  // render() {
  const contactEmail = booking.contact && booking.contact.email;
  const passengers = booking.passengers || [];
  const inAppBrowser = isInAppBrowser();

  const rConfirmationPage = ls.t('ConfirmationPage');
  if (!rConfirmationPage.BookingReference) return null;

  const rBookingStatus = ls.t('BookingStatus');
  const rButton = ls.t('Button');
  const rMessage = ls.t('WCI.ConfirmationPage.Message');
  const rPayment = ls.t('Payment');

  const bpMessage = stringFormatter.formatString(rMessage.BoardingPass, `<span>${contactEmail}</span>`);
  const additionalMessages = booking.additionalMessages || [];

  const showPendingPayment = paymentStatus?.status === 'pending';
  const pendingPayment = rPayment.Pending?.Desc ?? ['Your payment is being processed. You will receive a confirmation email once the payment is successful.'];


  const ratingTitle = ls.t(ratingKey) || 'RATE YOUR BOOKING EXPERIENCE?';
  const ratingMessage = ls.t(feedbackKey) || 'THANK YOU FOR YOUR FEEDBACK';

  return (
    <div
      className={ls.t("rootClass") + " main-container"}
      dir={ls.t("direction")}
    >
      <div className="header-con">
        <Header hasSummary={true} />
      </div>
      <Backdrop />
      {!inAppBrowser && <StatusBar path={match} label="confirmation" />}
      <div className="container confirmation padt20 padb40">
        <div className="min-height">
          <div className="booking-reference">
            <p>{rConfirmationPage.BookingReference}</p>
            <h2>{booking.pnr}</h2>
          </div>
          <h1>{rConfirmationPage.FlightDetails}</h1>
          <p className="booking-status">{rConfirmationPage.BookingStatus} <span>{rBookingStatus.CheckedIn}</span></p>
          <p className="confirm-message" dangerouslySetInnerHTML={{ __html: bpMessage }}></p>
          <AlertBox key={booking.pnr + '-pending-payment'} show={showPendingPayment} message={pendingPayment} />
          <AlertBox key={booking.pnr + '-pending'} show={additionalMessages.length > 0 && !booking.cancelledSegments?.length > 0}>
            {additionalMessages.map((line, index) => <p key={index}>{line}</p>)}
          </AlertBox>

          <ListGroup>
            {Array.isArray(booking.segments) &&
              booking.segments.map((segment, index) => (
                <FlightDetail
                  key={index}
                  passengers={passengers}
                  segment={segment}
                />
              ))}
          </ListGroup>
          <div className="clearfix btnCon">
            <Button
              type="submit"
              className="btn btn-primary pull-right flip btn-submit btn-effect"
              onClick={onBoardingPass}
            >
              <span>
                {rButton.ViewBoardingPass}
                <i className="picon picon-btn-arrow-right-w" />
              </span>
            </Button>
          </div>

          { redirectedFrom === 'checkout' &&
            <div className={"tw-mt-8 socialCon" + (inAppBrowser ? ' web-view' : '' )}>
              <RatingBar size={42} title={ratingTitle} message={ratingMessage} rated={rated}  onRate={sendFeedback} />
            </div>
          }
        </div>
      </div>
      {!inAppBrowser && <Footer />}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    booking: state.booking.details
  };
}

const mapDispatchToProps = {
  getBookingWithAllSegments: bookingActions.getBookingWithAllSegments,
  getBookingSummary: bookingActions.getBookingSummary,
  getBoardingPass: wciActions.getBoardingPass,
  feedback: wciActions.feedback,
  getBookingMode: sessionActions.getBookingMode
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation);
